<script>
import baseList from "@/views/components/base/baseConsumable.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import config from "@/../config";
import Check from "./check.vue";
import Stash from "./stash.vue";
import Stock from "./stock.vue";
import ImportTemplate from "@/views/components/common/form/consumablesImportTemplate.vue";
import CheckList from "./checkList.vue";
import CheckList2 from "./checkList2.vue";
import Promotion from "./promotion.vue";
import Replenishment from "./Replenishment.vue";
import logo from "../../assets/logo.png";
import QuoteVue from "./quote.vue";
import { IMAGE_HOST } from "@/../config";
import modalAmendVue from "./modalAmend.vue";
import typeofrequisitionVue from "./Typeofrequisition.vue";
import Show from "./Show.vue";
let customerId = window.localStorage.getItem("customerId");

export default {
  extends: baseList,
  components: {
    Check,
    Stash,
    Stock,
    QuoteVue,
    modalAmendVue,
    typeofrequisitionVue,
    Show,
  },
  data() {
    return {
      table: {
        mname: "consumables",
        key: "id",
        url: {
          del: "/admin/system/inventory",
        },
        output: false,
      },
      selectedConsumable: [],
      tabList: [],
      actions: [
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd,
          auth: "system/consumables/add",
          show: Number(customerId) == 0 ? true : false,
        },
        {
          label: "新增",
          icon: "md-add",
          type: "info",
          onClick: this.toAdd1,
          auth: "",
          show: Number(customerId) == 0 ? false : true,
        },
        {
          label: "导入",
          icon: "md-cloud-upload",
          onClick: this.toImport,
          auth: "system/consumables/import",
          type: "info",
          show: Number(customerId) == 0 ? true : false,
        },
        {
          label: "同步",
          icon: "md-refresh",
          onClick: this.onSync,
          type: "info",
          auth: "",
          show: Number(customerId) == 0 ? true : false,
        },
        {
          label: "推广",
          icon: "md-refresh",
          onClick: this.onImportCommon,
          type: "info",
          auth: "",
          show: Number(customerId) == 0 ? true : false,
        },
        {
          label: "下载模板",
          icon: "md-log-out",
          onClick: this.toDownload,
          auth: "system/consumables/download",
          type: "info",
          show: Number(customerId) == 0 ? true : false,
        },
        /* {
          label: "出库",
          onClick: this.toCheckList,
          auth: "",
          type: "info",
          show: Number(customerId) == 0 ? false : true,
        }, */
        {
          label: "补货",
          onClick: this.toCheckList1,
          auth: "",
          type: "info",
          show:
            Number(customerId) == 0
              ? false
              : Number(customerId) == 174
                ? false
                : true,
        },
        {
          label: "常用补货清单",
          type: "info",
          onClick: this.toAddReplenishment,
          auth: "system/consumables/add",
          show:
            Number(customerId) == 0
              ? false
              : Number(customerId) == 174
                ? false
                : true,
        },
      ],
      menus: [],
      filters: [
        {
          label: "采购人",
          KeyEnter: this.search,
          name: "purchase",
          value: "",
          type: "input",
        },
        {
          label: "耗材名称",
          KeyEnter: this.search,
          name: "name",
          value: "",
          type: "input",
        },
        {
          label: "型号",
          KeyEnter: this.search,
          name: "model",
          value: "",
          type: "input",
        },
        {
          label: "适用设备",
          KeyEnter: this.search,
          name: "remark",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          type: "selection",
          width: 60,
        },
        {
          title: "是否上架",
          key: "productBarcode",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.isshow == 1 ? "上架" : "下架";
            return (
              <Show
                text={text}
                item={row}
                onReset={() => {
                  this.search();
                }}
              />
            );
          },
        },
        {
          title: "货物信息",
          minWidth: 460,
          align: "center",
          render: (h, p) => {
            const text = Number(p.row.unitPrice).toFixed(2);
            const text1 = p.row.receiveState == 2 ? "目录外申请" : "目录内物资";
            return (
              <div style="display:flex; width:100%; padding:5px 0; align-items:center; text-align:left;">
                <el-image
                  v-show={customerId == 174 ? false : true}
                  style="width: 80px; height: 80px;flex-shrink: 0;"
                  src={
                    p.row.consumableImgUrl == "" ||
                      p.row.consumableImgUrl == null
                      ? logo
                      : IMAGE_HOST + p.row.consumableImgUrl
                  }
                  preview-src-list={[
                    p.row.consumableImgUrl == "" ||
                      p.row.consumableImgUrl == null
                      ? logo
                      : IMAGE_HOST + p.row.consumableImgUrl,
                  ]}
                >
                  {" "}
                  <div slot="error" class="image-slot">
                    <img style="width:80px;height:80px;" src={logo} />
                  </div>
                </el-image>
                <div style="flex: 1; margin-left: 10px;overflow: hidden;">
                  <div>
                    {customerId == 174 ? null : p.row.brand} {p.row.name} {p.row.model}
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content={p.row.remark}
                    placement="top-start"
                  >
                    <div style="width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                      {p.row.remark}
                    </div>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content={p.row.performanceParameter}
                    placement="top-start"
                  >
                    <div style="width: 100%; white-space: nowrap; text-overflow: ellipsis; overflow: hidden;">
                      {p.row.performanceParameter}
                    </div>
                  </el-tooltip>
                </div>
              </div>
            );
          },
        },
        {
          title: "单价",
          key: "unitPrice",
          width: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = Number(row.unitPrice).toFixed(2);
            if (customerId == 0) {
              return (
                <modalAmendVue
                  text={text}
                  item={row}
                  priceType="unitPrice"
                  onReset={() => {
                    this.search();
                  }}
                />
              );
            }
            return <span style="font-size: 14px;"> {text} </span>;
          },
        },
        {
          title: "库存",
          key: "num",
          width: 80,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.num;
            return h(
              "div",
              {
                style: {
                  color: row.num <= 10 ? "red" : "",
                  "font-size": "14px",
                  overflow: "hidden",
                  "text-overflow": "ellipsis",
                  "white-space": "nowrap",
                },
              },
              text
            );
          },
        },
        {
          title: "历史领用",
          key: "commonCount",
          width: 100,
          // sortable: true,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.commonCount ? row.commonCount : 0;
            return <span>{text}</span>;
          },
        },
        {
          title: "历史补货",
          key: "bhCount",
          width: 100,
          // sortable: true,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.bhCount ? row.bhCount : 0;
            return <span>{text}</span>;
          },
        },
        {
          title: "领用类型",
          width: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.receiveState == 2 ? "目录外申请" : "目录内物资";
            return (
              <typeofrequisitionVue
                text={text}
                item={row}
                onReset={() => {
                  this.search();
                }}
              />
            );
          },
        },
        // {
        //   title: "产品条码",
        //   key: "productBarcode",
        //   width: 120,
        //   align: "center",
        //   tooltip: "true",
        // },
        {
          title: "操作",
          align: "center",
          width: 150,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  v-show={
                    currentRow.receiveState == 1
                      ? true
                      : Number(customerId) == 0
                        ? true
                        : false
                  }
                  onClick={() => this.operation(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  操作
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              let directives3 = [
                { name: "auth", value: "system/procurementWork/add" },
              ];
              return (
                <Button
                  {...{ directives3 }}
                  size="small"
                  v-show={
                    currentRow.receiveState == 1
                      ? Number(customerId) != 174
                        ? true
                        : false
                      : false
                  }
                  onClick={() => this.toCheck1(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginLeft: "5px",
                  }}
                >
                  补货
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              return h(
                "Poptip",
                {
                  props: {
                    confirm: true,
                    title: "确定要加入补货清单吗?",
                    transfer: true,
                  },
                  on: {
                    "on-ok": () => {
                      this.toaddbu(currentRow);
                    },
                  },
                },
                [
                  h(
                    "div",
                    {
                      style: {
                        marginLeft: "5px",
                      },
                      directives: [
                        {
                          name: "show",
                          value:
                            currentRow.receiveState === 1 &&
                            Number(customerId) != 0 &&
                            Number(customerId) != 174,
                        },
                      ],
                    },
                    [
                      h(
                        "Button",
                        {
                          props: {
                            size: "small",
                            type: "default",
                            placement: "top",
                          },
                          style: {
                            border: "none",
                            margin: "4px 0px",
                            color: "#4991ff",
                          },
                        },
                        "加入补货清单"
                      ),
                    ]
                  ),
                ]
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.loadLevelData();
    if (customerId == 0) {
      let num = "";
      this.tableCols.forEach((item, index) => {
        if (item.key == "unitPrice") {
          num = index;
        }
      });
      this.tableCols.splice(num, 0, {
        title: "进货价",
        key: "jdPrice",
        width: 120,
        align: "center",
        render: (h, params) => {
          const row = params.row;
          const text = Number(row.jdPrice).toFixed(2);
          if (customerId == 0) {
            return (
              <modalAmendVue
                text={text}
                item={row}
                priceType="jdPrice"
                onReset={() => {
                  this.search();
                }}
              />
            );
          }
          return <span style={{ "font-size": "14px" }}> {text} </span>;
        },
      });
    }
    if (customerId == 174) {
      this.tableCols = this.tableCols.filter(item => item.key !== 'unitPrice');
    }
  },
  methods: {
    //选中
    handleSelect(selected) {
      let ids_arr = [];
      for (let index = 0; index < selected.length; index++) {
        const row = selected[index];
        let consumableIn = {};
        consumableIn.inventoryId = row.id;
        consumableIn.consumableNum = row.consumableNum;
        consumableIn.consumableImgUrl = row.consumableImgUrl;
        consumableIn.brand = row.brand;
        consumableIn.name = row.name;
        consumableIn.model = row.model;
        consumableIn.remark = row.remark;
        consumableIn.num = row.num;
        consumableIn.unit = row.unit;
        consumableIn.receiveNum = 1;
        consumableIn.introduceState = row.introduceState;
        consumableIn.consumableUuid = row.consumableUuid;
        consumableIn.unitPrice = row.unitPrice == null ? 0 : row.unitPrice;
        consumableIn.receiveNum = 1;
        consumableIn.receiveState = row.receiveState;
        ids_arr.push(consumableIn);
      }
      this.selectedConsumable = ids_arr;
    },
    everyType(e) {
      this.selectedConsumable = [];
      this.query.typeId = e;
      this.search();
      // this.$refs.tablelist.init();
    },
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {
        isParent: 1,
      };
      $utils.api
        .load("/admin/system/consumableType/selectList", q)
        .then((res) => {
          if (res && res.rows) {
            this.tabList = res.rows;
          }
        });
    },
    toStock(row) {
      this.$Modal.remove();
      let q = {};
      q.unit = row.unit;
      q.name = row.name;
      q.model = row.model;
      setTimeout(() => {
        $utils.api
          .load("/admin/system/inventory/listAdminSame", q, "GET")
          .then((res) => {
            this.$Modal.success({
              closable: true,
              title: "库存管理",
              width: "750px",
              height: "120px",
              okText: "取消",
              showOk: false,
              render: (h) => {
                return (
                  <Stock
                    style={{ margin: "0", color: "#19be6b" }}
                    onQuote={(e, id) => {
                      this.onQuote(e, id);
                    }}
                    inventoryId={row.id}
                    item={res.rows}
                  >
                    {" "}
                  </Stock>
                );
              },
            });
          });
      }, 300);
    },
    onQuote(row, id) {
      let q = row;
      q.num = 0;
      q.id = id;
      let d = [];
      d.push(q);
      $utils.api
        .load("/admin/system/inventory/addAdmin", d, "POST")
        .then((res) => {
          if (res.code == 200) {
            $utils.toast.success("引用成功");
            this.search();
          }
        });
    },
    toaddbu(row) {
      let q = { inventoryId: row.id };
      $utils.api.load("/admin/system/replenishment", q, "POST").then((res) => {
        if (res.code == 200) {
          $utils.toast.success("加入成功");
        }
      });
    },
    toCheck(row) {
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "领用记录",
          width: "1000px",
          okText: "取消",
          showOk: false,
          render: (h) => {
            return (
              <Check
                style={{ margin: "0", color: "#19be6b" }}
                inventoryId={row.id}
              >
                {" "}
              </Check>
            );
          },
        });
      }, 300);
    },
    toStash(row) {
      console.log(row);
      this.$Modal.remove();
      setTimeout(() => {
        this.$Modal.success({
          closable: true,
          title: "入库记录",
          width: "1000px",
          okText: "取消",
          showOk: false,
          render: (h) => {
            return (
              <Stash
                style={{ margin: "0", color: "#19be6b" }}
                inventoryId={row.id}
              >
                {" "}
              </Stash>
            );
          },
        });
      }, 300);
    },
    //单个采购
    toCheck1(row) {
      this.$Modal.remove();
      setTimeout(() => {
        let consumableIn = {};
        consumableIn.inventoryId = row.id;
        consumableIn.consumableNum = row.consumableNum;
        consumableIn.consumableImgUrl = row.consumableImgUrl;
        consumableIn.brand = row.brand;
        consumableIn.name = row.name;
        consumableIn.model = row.model;
        consumableIn.remark = row.remark;
        consumableIn.num = row.num;
        consumableIn.unit = row.unit;
        consumableIn.receiveNum = 1;
        consumableIn.introduceState = row.introduceState;
        consumableIn.consumableUuid = row.consumableUuid;
        consumableIn.unitPrice = row.unitPrice == null ? 0 : row.unitPrice;
        let consumableInventory = [];
        consumableInventory.push(consumableIn);
        this.$Modal.success({
          closable: true,
          title: "补货",
          okText: "取消",
          width: "1100px",
          showOk: false,
          render: (h) => {
            return (
              <CheckList2
                style={{ margin: "0", color: "#19be6b" }}
                consumableInventory={consumableInventory}
              ></CheckList2>
            );
          },
        });
      }, 300);
    },
    toCheckList1() {
      let isReceiveState = false;
      if (!this.selectedConsumable.length > 0) {
        return $utils.toast.error("请选择耗材!");
      }
      this.selectedConsumable.forEach((item) => {
        if (item.receiveState == 2) {
          isReceiveState = true;
        }
      });
      if (isReceiveState) {
        return $utils.toast.error("目录外申请的物资不能补货!");
      }
      this.$Modal.success({
        closable: true,
        title: "补货",
        width: "1100px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CheckList2
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={this.selectedConsumable}
            ></CheckList2>
          );
        },
      });
    },
    toAddReplenishment() {
      this.$Modal.success({
        closable: true,
        title: "常用补货清单",
        width: "1100px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Replenishment
              style={{ margin: "0", color: "#19be6b" }}
            ></Replenishment>
          );
        },
      });
    },
    toClaim(row) {
      this.$Modal.remove();
      setTimeout(() => {
        let consumableIn = {};
        consumableIn.inventoryId = row.id;
        consumableIn.consumableNum = row.consumableNum;
        consumableIn.consumableImgUrl = row.consumableImgUrl;
        consumableIn.brand = row.brand;
        consumableIn.name = row.name;
        consumableIn.model = row.model;
        consumableIn.remark = row.remark;
        consumableIn.num = row.num;
        consumableIn.unit = row.unit;
        consumableIn.receiveNum = 1;
        let consumableInventory = [];
        consumableInventory.push(consumableIn);
        this.$Modal.success({
          closable: true,
          title: "领用",
          okText: "取消",
          width: "1000px",
          showOk: false,
          render: (h) => {
            return (
              <CheckList
                style={{ margin: "0", color: "#19be6b" }}
                consumableInventory={consumableInventory}
              >
                {" "}
              </CheckList>
            );
          },
        });
      }, 300);
    },
    toAdd() {
      $utils.url.push({ name: "consumables_add", query: { action: "add" } });
    },
    toAdd1() {
      $utils.url.push({ name: "consumables_list_admin" });
    },
    handleEdit(currentRow) {
      this.$Modal.remove();
      $utils.url.push({
        name: "consumables_edit",
        query: { action: "edit", kv: currentRow.id },
      });
    },
    toImport() {
      this.$Modal.success({
        closable: true,
        title: "导入模板",
        width: "1200px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <ImportTemplate
              style={{ margin: "0", color: "#19be6b" }}
              refListTable={() => {
                this.search();
              }}
            >
              {" "}
            </ImportTemplate>
          );
        },
      });
    },
    toCheckList() {
      if (!this.selectedConsumable.length > 0) {
        return $utils.toast.error("请选择耗材!");
      }
      this.$Modal.success({
        closable: true,
        title: "领用",
        width: "1000px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <CheckList
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={this.selectedConsumable}
            >
              {" "}
            </CheckList>
          );
        },
      });
    },

    //下载模板
    toDownload() {
      window.location.href =
        config.API_HOST + `/admin/system/inventory/template/download`;
    },
    operation(currentRow) {
      let directives = [{ name: "auth", value: "system/consumables/stock" }];
      let directives1 = [{ name: "auth", value: "system/consumables/claim" }];
      let directives2 = [{ name: "auth", value: "system/consumables/check" }];
      this.$Modal.success({
        closable: true,
        title: "操作",
        width: "800px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <Button
                {...{ directives }}
                vShow={Number(customerId) == 0 ? true : false}
                size="small"
                onClick={() => this.handleEdit(currentRow)}
                type="default"
                style={{
                  border: "none",
                  color: "#4991ff",
                  marginLeft: "5px",
                }}
              >
                编辑
              </Button>
              <Button
                {...{ directives }}
                size="small"
                vShow={currentRow.receiveState == 2 ? false : true}
                onClick={() => this.toStock(currentRow)}
                type="default"
                style={{
                  border: "none",
                  color: "#4991ff",
                  marginLeft: "5px",
                }}
              >
                入库
              </Button>
              <Button
                {...{ directives2 }}
                size="small"
                vShow={currentRow.receiveState == 2 ? false : true}
                onClick={() => this.toStash(currentRow)}
                type="default"
                style={{
                  border: "none",
                  color: "#4991ff",
                  marginLeft: "5px",
                }}
              >
                入库记录
              </Button>
              <Button
                {...{ directives2 }}
                size="small"
                vShow={currentRow.receiveState == 2 ? false : true}
                onClick={() => this.toCheck(currentRow)}
                type="default"
                style={{
                  border: "none",
                  color: "#4991ff",
                  marginLeft: "5px",
                }}
              >
                领用记录
              </Button>
            </div>
          );
        },
      });
    },
    /* 
     <Button
                {...{ directives1 }}
                size="small"
                vShow={currentRow.receiveState == 2 ? false : true}
                onClick={() => this.toClaim(currentRow)}
                type="default"
                style={{
                  border: "none",
                  color: "#4991ff",
                }}
              >
                出库
              </Button>
     */
    async onSync() {
      let q = {};
      let res = await $utils.api.load(
        "/admin/system/inventory/implAdmin",
        q,
        "post"
      );
      // console.log(res);
      if (res.code == 200) {
        $utils.toast.success("同步成功！");
      }
    },
    async onImportCommon() {
      this.selectedConsumable;
      this.$Modal.success({
        closable: true,
        title: "推广",
        width: "1000px",
        height: "900px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <Promotion
              style={{ margin: "0", color: "#19be6b" }}
              consumableInventory={this.selectedConsumable}
            >
              {" "}
            </Promotion>
          );
        },
      });
      /* 
      
      let res = await $utils.api.load(
        "/admin/system/inventory/implCommonAdmin",
        q,
        "post"
      );
      if (res.code == 200) {
        $utils.toast.success("推广成功！");
        this.search();
      } else {
        $utils.toast.error(res.message);
      } */
    },
  },
};
</script>

<style scoped></style>
